import { useParams } from 'react-router-dom';

import { useRuntime } from '@/legacy/components/RuntimeProvider';
import { DemandConversation } from '~/routes/DemandConversation/DemandConversation';

import { DemandConversationPageHeaderForExtension } from './DemandConversationPageHeaderForExtension';

export const DemandConversationPage = () => {
  const { id } = useParams<{ id: string }>();
  const { runtime } = useRuntime();

  return id ? (
    <DemandConversation
      demandId={id}
      header={runtime.type === 'browserExtension' ? <DemandConversationPageHeaderForExtension /> : null}
    />
  ) : null;
};
